import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid";
import ComplexStatisticsCard from "components/Cards/StatisticsCards/ComplexStatisticsCard";
import MDBox from "components/MDBox";

export default function CardsDash({ loading, cardsData }) {

    return (
        <Grid container mt={1} spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                    <ComplexStatisticsCard
                        color="warning"
                        icon={loading ? <CircularProgress style={{ color: "#fff" }} size={"24px"} /> : <i class="fa-solid fa-calendar-days"></i>}
                        title="Abertos"
                        count={Array.isArray(cardsData) ? (cardsData.find(x => x.estado === '1')?.total || 0) : 0}
                    />
                </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                    <ComplexStatisticsCard
                        color="dark"
                        icon={loading ? <CircularProgress style={{ color: "#fff" }} size={"24px"} /> : <i class="fa-solid fa-xmark"></i>}
                        title="Não aplicáveis"
                        count={Array.isArray(cardsData) ? (cardsData.find(x => x.estado === '2')?.total || 0) : 0}
                    />
                </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                    <ComplexStatisticsCard
                        color='success'
                        icon={loading ? <CircularProgress style={{ color: "#fff" }} size={"24px"} /> : <i class="fa-solid fa-check"></i>}
                        title="Fechados"
                        count={Array.isArray(cardsData) ? (cardsData.find(x => x.estado === '3')?.total || 0) : 0}
                    />
                </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                    <ComplexStatisticsCard
                        icon={loading ? <CircularProgress style={{ color: "#fff" }} size={"24px"} /> : <i class="fa-solid fa-chart-simple"></i>}
                        title="Total"
                        count={Array.isArray(cardsData) ? ((cardsData.find(x => x.estado === '1')?.total || 0) + (cardsData.find(x => x.estado === '2')?.total || 0) + (cardsData.find(x => x.estado === '3')?.total || 0)) : 0}
                    />
                </MDBox>
            </Grid>
        </Grid>
    )
}